if($('.faq-item').hasClass('active')){
    $('.faq-item').children('.faq-header').attr('aria-expanded','true');
  } else {
    $('.faq-item').children('.faq-header').attr('aria-expanded','false');
 }

$('.faq-item').click(function(){
  if($(this).hasClass('active')){
    $(this).children('.faq-header').attr('aria-expanded','true');
  } else {
    $(this).children('.faq-header').attr('aria-expanded','false');
  }
})

$('.slider_control_btn').click(function(){
	if($('.slider_control').hasClass('slider-pause')){
      $('.hero_img_slider ').slick('slickPause')
      $('.slider_control').removeClass('slider-pause');
      $('.slider_control').attr('aria-label','slider-play');
      $('.slider_control').addClass('slider-play');
      
      
    } else if($('.slider_control').hasClass('slider-play')){
      $('.hero_img_slider ').slick('slickPlay')
      $('.slider_control').removeClass('slider-play');
      $('.slider_control').addClass('slider-pause');
      $('.slider_control').attr('aria-label','slider-pause');
    }
})

$('.shades-list-item label').keypress(function(e){
  if(e.which == 13){
    $(this).click();
  }
});

$('.quantity-wrappper .qtyminus,.quantity-wrappper .qtyplus').keypress(function(e){
  if(e.which == 13){
    $(this).attr('aria-pressed','true');
    setTimeout(function() { 
        $('[aria-pressed=true]').removeAttr('aria-pressed');
    }, 500);
  }
});

// $('.tx-pricebox .item_remove.remove_cart').keypress(function(e){
//   if(e.which == 13){
//     $(this).click();
//   }
// });

$(document).ready(function() {
  $("#AccessibleNav").accessibleDropDown();
});


$.fn.accessibleDropDown = function() { 
    
  $('.site-nav--has-dropdown .navWrapperDropdown a').focus(function(e) {
    e.preventDefault();
    $(".site-nav--has-dropdown").removeClass('nav-hover');
  });
  
  
  $('.site-nav--no-dropdown').keyup(function(){
    $(".site-nav--has-dropdown").removeClass('nav-hover');
    // $(".site-nav--has-dropdown").attr('aria-expanded', 'false');

  });
}

$(".site-nav--has-dropdown button").click(function() {
  $(this).parent().parent().toggleClass('nav-hover');
  if($(this).attr('aria-expanded') == 'false') {
  		$(this).attr('aria-expanded', 'true');
  } else {
    	$(this).attr('aria-expanded', 'false');
  }
})

/* UK ADA fixes - ID: 53 */

$('#k_id_email-1').focus(function(e) {
    $('.email__wrapper label').addClass('has-focus');
});

$('#k_id_email-1').blur(function(e) {
  if (!$(this).val()) {
    $('.email__wrapper label').removeClass('has-focus');
  }
});

$('#k_id_email').focus(function(e) {
    $('.email_wrapper_mob label').addClass('has-focus');
});

$('#k_id_email').blur(function(e) {
  if (!$(this).val()) {
    $('.email_wrapper_mob label').removeClass('has-focus');
  }
});

/* UK ADA fixes - ID: 131 */

$('#CustomerEmail').focus(function(e) {
    $('.customerEmailWrapper label').addClass('custom-focus');
});

$('#CustomerEmail').blur(function(e) {
  if (!$(this).val()) {
      $('.customerEmailWrapper label').removeClass('custom-focus');
  }
});

$('#CustomerPassword').focus(function(e) {
    $('.customerPassWrapper label').addClass('custom-focus');
});

$('#CustomerPassword').blur(function(e) {
    if (!$(this).val()) {
    	$('.customerPassWrapper label').removeClass('custom-focus');
    }
});

/* UK ADA fixes - ID: 182 */

$('.template-product').keydown(function(e){
    var key = e.keyCode;
    if (key === 9) { 
        $('.template-product .slick-arrow[aria-disabled="true"]').attr('tabindex', '-1');
        $('.template-product .slick-arrow[aria-disabled="false"]').attr('tabindex', '0');
    }
});

/* UK ADA fixes - ID: 116 */


let drawer, drawerfirstElement, drawerlastElement;

window.addEventListener('load', function(e) {
  drawer = document.querySelector('#CartDrawer');
  drawerfirstElement = drawer.querySelector('.js-drawer-close button');
  drawerlastElement = drawer.querySelector('.lastFocus');

  drawer.addEventListener('keydown', function(e) {
    drawer = document.querySelector('#CartDrawer');
  	drawerfirstElement = drawer.querySelector('.js-drawer-close button');
  	drawerlastElement = drawer.querySelector('.lastFocus');
    if(e.target == drawerfirstElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      drawerlastElement.focus();
    } 
    else if(e.target == drawerlastElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      drawerfirstElement.focus();
    }
  });
});

/* UK ADA fixes - ID: 100 */

$('#selectedShadedropdown,#shadeDropdownList .shade-item,.inputrange #qunatityInput').keypress(function(e){
  if(e.which == 13){
    $(this).click();
  }
});

/* UK ADA fixes - ID: 169 */

$("body").on("click", '#eci-morelink', function(){
  $(".eci-collection-description").focus();
});

$("body").on("click", '#eci-lesslink', function(){
  setTimeout(function() {
  	$("#eci-morelink").focus();
  }, 500);
});

/* UK ADA fixes - ID: 104 */

/*Product info*/
let tablist, tabs, tabpanels;

window.addEventListener('DOMContentLoaded', function(e) {
  tablist = document.querySelector('.tab-wrapper');
  tabs = document.querySelectorAll('.tab-toggle');
  tabpanels = document.querySelectorAll('.tabpanel');

  // Select previous/next tabs using Left and Right arrow keys
   if (tablist != null) {
    tablist.addEventListener('keydown', function(e) {
    switch(e.key) {
      case 'ArrowLeft':
        selectPreviousTab();
        break;
        
      case 'ArrowRight':
        selectNextTab();
        break;

      case 'Home': 
        e.preventDefault();  
        selectFirstTab();
        break;
        
      case 'End':  
        e.preventDefault();
        selectLastTab();
        break;
    }
  });
   }

// Activate tabs when they are clicked (also handles Enter and Space keys)
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      nextTabIndex = Array.prototype.slice.call(tabs).indexOf(e.target);
      selectTab(nextTabIndex);
    });
  });  
});

/**
  Tab selection
*/
function selectPreviousTab() {
  var activeTab = document.querySelector('.tab-toggle[aria-selected="true"]');
  var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);

  // Select the previous tab, wrapping to last tab if needed
  if(activeTabIndex > 0) {
    selectTab(activeTabIndex - 1);
  } else {
    selectTab(tabs.length - 1);
  }
}

function selectNextTab() {
  var activeTab = document.querySelector('.tab-toggle[aria-selected="true"]');
  var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);

  // Select the next tab, wrapping to the first tab if needed 
  if(activeTabIndex < tabs.length - 1) {
    selectTab(activeTabIndex + 1);
  } else {
    selectTab(0);
  }
}

function selectFirstTab() {
  selectTab(0);
}

function selectLastTab() {
  selectTab(tabs.length - 1);
}

function selectTab(index) {
  // Deactivate all tabs
  tabs.forEach(function(tab) {
    tab.setAttribute('aria-selected', false);
    tab.setAttribute('tabindex', -1);
  });
  
  // Activate only the requested tab, and set focus to it
  tabs[index].setAttribute('aria-selected', true);
  tabs[index].setAttribute('tabindex', 0);
  tabs[index].focus();
  
  // Hide all tabpanels
  tabpanels.forEach(function(tabpanel) {
    tabpanel.classList.remove('is-visible');
  });
  
  // Show only the tabpanel for the requested tab
  var nextTabpanel = document.querySelector('#' + tabs[index].getAttribute('aria-controls'));
  nextTabpanel.classList.add('is-visible');
}

/* UK ADA fixes - ID: 136, 162 */

// $('.mobile-nav .mob_closeIcon').on('click', function(){
//   $('#menuToggleButton').attr('aria-expanded','false');
// });

let mobileNav = document.querySelector('.mobile-nav');
let firstNavElement = document.querySelector('.mob_closeIcon button');
let lastNavElement = document.querySelector('#NavDrawer .country-top-btn button');

mobileNav.addEventListener('keydown', function(e) {
  if(e.target == firstNavElement && e.key == 'Tab' && e.shiftKey) {
    e.preventDefault();
    lastNavElement.focus();
  } else if(e.target == lastNavElement && e.key == 'Tab' && !e.shiftKey) {
    e.preventDefault();
    firstNavElement.focus();
  }
});

// ADA fixes #186
 // $('.filter-group ul .collection-container').attr('tabindex','1');


// UK close button focus
  $("#cartItemL").click(function (e) { 
        
         setTimeout(() => {
          $(".icon-fallback-text.firstFocus").focus();
        }, 1000);
    
      });

$('#shadeDropdownList .shade-item').keydown(function(e){
    var key = e.keyCode;
    if (key === 13) { 
    $(this).parents('.custom-shade-select').find('#selectedShadedropdown').focus();
    $(this).trigger("click");}
});

//AJAX Card loading issue
$(window).on('load', function() {
  setTimeout(function(){
    $('body').addClass('is-page-loaded');
  },500)
});

// Custom radio ADA
window.addEventListener("DOMContentLoaded", () => {
  let customRadio = document.querySelectorAll('.product-details-subscription #AddToCartForm [role="radio"]');
  let customRadioList = document.querySelector('.product-details-subscription #AddToCartForm [role="radiogroup"]');
  let tabFocus = 0;
  if(customRadioList){
  customRadioList.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      customRadio[tabFocus].setAttribute("tabindex", -1);
      if (e.key === "ArrowRight") {
        tabFocus++;
        if (tabFocus >= customRadio.length) {
          tabFocus = 0;
        }
      } else if (e.key === "ArrowLeft") {
        console.log('ArrowLeft');
        tabFocus--;
        if (tabFocus < 0) {
          tabFocus = customRadio.length - 1;
        }
      }
      customRadio[tabFocus].setAttribute("tabindex", 0);
      customRadio[tabFocus].focus();
    }
  });
  }
});

if($('.hero_img_slider .slide').hasClass('slide--multi')){
  $('.slider_control_btn').css('display', 'flex');
}
$(document).ready(function(){
$('.hero_img_slider').slick({
        adaptiveHeight: true,
        autoplay: true,
  	  autoplaySpeed: 5000,
  	  pauseOnHover:true
});
})
